import React, { ReactElement } from 'react';
export default function Accordion({ children }: { children: ReactElement | ReactElement[] }) {
    return (
        <div className="accordion" id="accordionExample">
            {children}
        </div>
    );
}